
<template>
    <div>
        <div class="overlay" @click="onCancelPassword"></div>
        <div class="modal password-modal">
            <form class="form-wrapper"
                v-on:submit.prevent="onSubmitPassword(options.gameId, localPassword)">
                <div class="form-control-wrapper password-input-wrapper">
                    <input
                        class="form-control outline password-input"
                        v-model="localPassword"
                        name="room-password"
                        type="password"
                        placeholder="Enter room password"
                    />
                    <fa-icon class="icon" icon="lock" />
                </div>
                <div class="form-control-wrapper">
                    <input class="btn btn-primary btn-block" type="submit" value="Submit" />
                </div>
            </form>
            <div class="form-control-wrapper text-center">
                <div class="cancel-btn" @click="onCancelPassword">
                    Cancel
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: ['options'],
    name: 'PasswordModal',
    data() {
        return {
            localPassword: this.options?.password ?? '',
        };
    },
    watch: {
        options: {
            handler(newOptions) {
                this.localPassword = newOptions?.password ?? '';
            },
            deep: true,
        },
    },
    methods: {
        onCancelPassword() {
            this.$store.dispatch('closePasswordModal');
        },
        onSubmitPassword(gameId, password) {
            if (!password) {
                this.$notify({
                    group: 'app',
                    clean: true,
                });

                this.$notify({
                    group: 'app',
                    title: '',
                    type: 'info',
                    text: 'Password required',
                });
                return;
            }

            const options = {
                gameId,
                password,
            };

            this.$store.dispatch('joinRoom', options);
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .password-modal {
        padding: 20px;
        min-width: 275px;

        .form-img {
            height: 50px;
            width: auto;
        }

        .form-control-wrapper {
            margin: 15px auto;

            &:last-of-type {
                margin-bottom: 0;
            }
        }

        .password-input-wrapper {
            position: relative;

            .password-input {
                padding-left: 31px;

                &::placeholder {
                    color: $dark-blue;
                }
            }

            .icon {
                position: absolute;
                left: 10px;
                top: 50%;
                transform: translateY(-50%);
            }
        }

        .cancel-btn {
            cursor: pointer;
        }
    }

</style>
